import { render, staticRenderFns } from "./aliveTab.vue?vue&type=template&id=8c1575e8&"
import script from "./aliveTab.vue?vue&type=script&lang=js&"
export * from "./aliveTab.vue?vue&type=script&lang=js&"
import style0 from "./aliveTab.vue?vue&type=style&index=0&id=8c1575e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports